import {JetView} from "webix-jet"; // Importing JetView from webix-jet framework
import {allpayments} from "models/allpayments"; // Importing allpayments model
import {devConfig} from "config/config"; // Importing development configuration

export default class tableComissionsView extends JetView {
	/**
	 * Configures the view layout and components.
	 * @returns {Object} Configuration object for the datatable view.
	 */
	config(){
		const _ = this.app.getService("locale")._; // Localization service
		const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
		const cur_user = this.getParam("user", true); // Get current user parameter

		return {
			view:"datatable", // Main view type
			css: "webix_header_border webix_data_border", // CSS classes for styling
			id: "datatable", // Unique identifier for the datatable
			select:true, // Enable row selection
			minHeight: 300, // Minimum height of the datatable
			columns:[ // Column definitions for the datatable
				{ id:"rating",	header:"",width:50, height: 25, tooltip:"Editar", // Column for editing
			      template:function(obj){ // Template function for rendering edit icon
			      	if (devConfig.getPermAction("betShopComissionsEdit", "Edit")) { // Check permissions
			      		return "<span class='webix_icon wxi-close edit'></span>"; // Return edit icon
			      	} else {
			      		return ""; // No icon if no permission
			      	}
			      }
			  },
				{ id:"Id", header:"Id", width:200, sort:"int",hidden:true}, // Hidden ID column
				{ id:"ProductName", header:_("Producto"), width:250, sort:"int" }, // Product name column
				{ id:"ComissionLevelBetShop", header:_("Comisión Usuario"), width:220, sort:"int"}, // User commission column
				{ id:"ComissionLevel1", header:_("Por Concesionario"), width:130, sort:"int"}, // Commission level 1 column
				{ id:"ComissionLevel2", header:_("Por Subconcesionario"), width:130, sort:"int"}, // Commission level 2 column
				{ id:"ComissionLevel3", header:_("Por Subconcesionario 1"), width:130, sort:"int"}, // Commission level 3 column
				{ id:"ComissionLevel4", header:_("Por Subconcesionario 2"), width:130, sort:"int"}, // Commission level 4 column
				{ id:"Total", header:_("Total"), width:130, sort:"int"} // Total commission column
			],
			scheme:{ // Data scheme for calculations
		       $change: function calck_c(obj){ // Function to calculate total commission
					obj.Total = obj.ComissionLevelBetShop*1 + obj.ComissionLevel1*1 + obj.ComissionLevel2*1 + obj.ComissionLevel3*1 + obj.ComissionLevel4*1; // Calculate total
				}
		     },
			tooltip:true, // Enable tooltips
			math: true, // Enable math operations
      loadahead:devConfig.getDefaultDataFetch(), // Load ahead configuration
			pager: "pagerA", // Pager ID for pagination
      url:devConfig.geturlApi() + "es/BetShop/GetAgentComissionItems?FromId=" + cur_user + "&", // API URL for data fetching
			onClick:	{ // Event handler for click events
				"edit":function(euv, id){ // Edit button click event
					$$("editwinComissions").show(); // Show edit window
		    }
		  },
			tooltip:true // Enable tooltips
		};
	}

	/**
	 * Initializes the datatable and its events.
	 * @param {Object} grid - The datatable instance.
	 */
	init(grid){
		const _ = this.app.getService("locale")._; // Localization service
		var url = grid.data.url; // Store the grid URL
		const cur_user = this.getParam("user", true); // Get current user parameter

		grid.attachEvent("onAfterSort", function(by, dir, as){ // Event after sorting
				grid.load(url + '?start=0&count=' + grid.data.$pagesize + '&sort['+by+']=' + dir ); // Reload data with sorting
		});

		grid.attachEvent("onItemClick", function(id, e, node){ // Event on item click
			var item = this.getItem(id); // Get clicked item
			this.$scope.app.callEvent("user:id",[item.Id]); // Trigger user ID event
		});

		var popup = webix.ui({ // Create edit window UI
				view: "window",
				id: "editwinComissions", // Unique ID for the edit window
				head: "Editar Comisión", // Window header
				head: {
						view:"toolbar", // Toolbar for the header
						cols:[
							{view:"label", label:_("Editar Comisión")}, // Label for the toolbar
							{view:"icon", icon:"wxi-close", click:function(){ // Close icon with click event
								this.getTopParentView().hide(); // Hide the window
							}}
						]
				},
				position: "center", // Center position of the window
				modal: true, // Modal window
				body: {
						view: "form", id: "editformComissions",  elements: [ // Form for editing commissions
						{view: "text", label: "Id", labelWidth:150, name: "Id", readonly: true,hidden:true}, // Hidden ID field
						{view: "text", label: _("Producto"), labelWidth:150, name: "ProductName", readonly: true}, // Readonly product name field
						{view: "text", label: _("Comisión Usuario"),  labelWidth:150, name: "ComissionLevelBetShop", readonly: false, type:"number"}, // Editable user commission field
						{view: "text", label: _("Por Concesionario"), labelWidth:150, name: "ComissionLevel1", readonly: false, type:"number"}, // Editable commission level 1 field
						{view: "text", label: _("Por Subconcesionario"),  labelWidth:150, name: "ComissionLevel2", readonly: false, type:"number"}, // Editable commission level 2 field
						{view: "text", label: _("Por Subconcesionario 1"),  labelWidth:150, name: "ComissionLevel3", readonly: false, type:"number"}, // Editable commission level 3 field
						{view: "text", label: _("Por Subconcesionario 2"),  labelWidth:150, name: "ComissionLevel4", readonly: false, type:"number"}, // Editable commission level 4 field
						{view: "text", id: "Total", label: _("Total"),  labelWidth:150, name: "Total", readonly: true, disabled:true, type:"number"}, // Readonly total field
						{
										cols: [ // Button layout
												{
														view: "button", value: _("Cancelar"), click: function () { // Cancel button
																this.getTopParentView().hide(); // Hide the window
														}
												},
												{
														view: "button", type: "form", value: _("Guardar"), click: function ($e) { // Save button
																var values = $$("editformComissions").getValues(); // Get form values
																webix.ajax().headers({ // AJAX request to save data
																		"Content-type": "application/json"
																}).post(devConfig.geturlApi() + "BetShop/SaveComissions", '{"FromId":"' + cur_user + '","Id":"' + values.Id + '","ProductName":"' + values.ProductName + '","ComissionLevel1":"' + values.ComissionLevel1 + '","ComissionLevel2":"' + values.ComissionLevel2 + '","ComissionLevel3":"' + values.ComissionLevel3 + '","ComissionLevel4":"' + values.ComissionLevel4 + '","ComissionLevelBetShop":"' + values.ComissionLevelBetShop + '"}', {
																		error: function (text, data, XmlHttpRequest) { // Error handling
																				webix.message(_("Error! ")); // Show error message
																		},
																		success: function (text, data, XmlHttpRequest) { // Success handling
																				webix.message(_("Valores Editados")); // Show success message
																				grid.clearAll(); // Clear grid data
																				grid.load(url); // Reload grid data
																		}
																});
																this.getTopParentView().hide(); // Hide the window
														}
												}
										]
								}
						],on:{ // Event handlers for form
								    onChange(){ // On change event
								    	var values = $$("editformComissions").getValues(); // Get form values
										values.Total = values.ComissionLevelBetShop*1 + values.ComissionLevel1*1 + values.ComissionLevel2*1 + values.ComissionLevel3*1 + values.ComissionLevel4*1; // Calculate total
										$$("Total").setValue(values.Total); // Set total value in the form
								    }
								  },
				}
		});

		this.on(this.app,"player:select",Id => { // Event for player selection
			grid.load(grid.data.url+'?start=0&count='+grid.data.$pagesize+'&FromId='+Id); // Load grid data based on selected player
		});

		grid.attachEvent("onItemDblClick", function (id, e, node) { // Event for double-click on item
			if(devConfig.getPermAction("permComissions", "Edit")){ // Check edit permissions
				popup.show(); // Show edit window
			}
		});

		$$("editformComissions").bind($$("datatable")); // Bind form to datatable
	}
}

// FILE DOCUMENTED
